import { useEffect } from "react";
import { useNavigate, Outlet, NavLink as RouterNavLink } from "react-router-dom";
import { adminAuth } from "@/services/adminAuth";
import { Button } from "@/components/ui/button";
import { Package, LogOut } from "lucide-react";

export function AdminLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check auth on mount and redirect if not authenticated
    if (!adminAuth.isAuthenticated()) {
      navigate("/admin/login", { replace: true });
    }
  }, [navigate]);

  const handleLogout = () => {
    adminAuth.logout();
    navigate("/admin/login", { replace: true });
  };

  // Don't render until we know auth state
  if (!adminAuth.isAuthenticated()) {
    return null;
  }

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 bg-card border-r flex flex-col">
        <div className="p-6 border-b">
          <h1 className="text-xl font-bold font-playfair">Admin Panel</h1>
          <p className="text-sm text-muted-foreground">idacoromania.ro</p>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          <RouterNavLink
            to="/admin/dashboard"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "hover:bg-muted"
              }`
            }
          >
            <Package className="h-5 w-5" />
            <span>Products</span>
          </RouterNavLink>
        </nav>

        <div className="p-4 border-t">
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={handleLogout}
          >
            <LogOut className="h-5 w-5 mr-3" />
            Logout
          </Button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
